// newsletter_signup, as live's leaf_newsletter_signup.js: any form carrying the hidden `newsletter` contact tag.
document.addEventListener('submit', (event) => {
  if (!(event.target instanceof HTMLFormElement)) return;
  if (!event.target.querySelector('input[name="contact[tags]"][value="newsletter"]')) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'newsletter_signup' });
}, true);
